import { ConstructionSiteDocumentType } from "@dune/types";
import { documentTypeLabels } from "@dune/vars";

export const isConstructionSiteDocumentType = (
	type: string,
): type is ConstructionSiteDocumentType => {
	return type in documentTypeLabels;
};

export const downloadFileWithName = async (
	url: string,
	filename: string,
): Promise<void> => {
	const response = await fetch(url);
	if (!response.ok) {
		throw new Error(`Failed to fetch file: ${response.statusText}`);
	}

	const blob = await response.blob();
	const blobUrl = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = blobUrl;
	link.download = filename;
	link.click();
	URL.revokeObjectURL(blobUrl);
};
